import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthenticationService } from '@csx/security';
import { environment } from '../../environments/environment';

declare var gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  constructor(private router: Router, private authService: AuthenticationService) { }

  init(): void {
    if (!this.isGoogleAnalyticsEnabled()) {
      console.error('Google analytics is not enabled.');
      return;
    }

    try {
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = environment.appConfig.googleAnalyticsURL + environment.appConfig.googleAnalyticsTrackingId;
      document.head.appendChild(script1);

      const script2 = document.createElement('script');
      script2.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '` + environment.appConfig.googleAnalyticsTrackingId + `', {'send_page_view': false});`;

      document.head.appendChild(script2);

      if (typeof this.authService.user.racf !== 'undefined' && this.authService.user.racf) {
        gtag('set', { 'user_id': '' + this.authService.user.racf + '' });

        //add user id as custom dimension
        gtag('config', environment.appConfig.googleAnalyticsTrackingId, {
          'custom_map': {
            'dimension1': 'userIdDimension'
          }
        });
        gtag('event', 'userIdDimension_event', { 'userIdDimension': this.authService.user.racf });
      }
      this.listenForRouteChanges();
    } catch (ex) {
      console.error('Error appending google analytics');
      console.error(ex);
    }
  }

  private isGoogleAnalyticsEnabled(): boolean {
    return typeof environment.appConfig.googleAnalyticsTrackingId != "undefined" &&
      environment.appConfig.googleAnalyticsTrackingId != null &&
      environment.appConfig.googleAnalyticsTrackingId != '' &&
      environment.appConfig.googleAnalyticsTrackingId !== 'disabled';
  }

  private listenForRouteChanges(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        let urlWithoutParams = event.urlAfterRedirects.split('?')[0].replace(/[0-9]/g, '').replace(/\/\/+/g, '/').replace(/\/\/+/g, '');
        let rootUrlPath = event.urlAfterRedirects.split('/')[1].split('?')[0];

        if (rootUrlPath.includes(':')) {
          // handle aux routes
          rootUrlPath = rootUrlPath.split(':')[1];
        }
        rootUrlPath = rootUrlPath.split('-').join(' ');

        gtag('config', environment.appConfig.googleAnalyticsTrackingId, {
          'page_path': urlWithoutParams,
          'page_title': rootUrlPath
        });
      }
    });
  }
}
